import NextHead from 'next/head'
import React, { FunctionComponent } from 'react'

export interface HeadProps {
  title: string
  setMobileStatusBarColor?: string
}

export const Head: FunctionComponent<HeadProps> = ({ title, setMobileStatusBarColor = '#FFFFFF' }) => {
  return (
    <NextHead>
      <title>{title}</title>
      <meta property='og:title' content={title} />
      <meta name='viewport' content='initial-scale=1.0, width=device-width, maximum-scale=1.0, user-scalable=no' key='viewport' />
      <meta name='theme-color' content={setMobileStatusBarColor} />
    </NextHead>
  )
}
